// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamSummary .team-title {
  margin-top: 0; }

.TeamSummary .names {
  list-style: none;
  text-align: left;
  padding: 0; }

.TeamSummary + .TeamSummary {
  margin-top: 2rem; }
`, "",{"version":3,"sources":["webpack://./src/components/TeamSummary.scss"],"names":[],"mappings":"AAAA;EAEI,aAAa,EAAA;;AAFjB;EAMI,gBAAgB;EAChB,gBAAgB;EAChB,UAAU,EAAA;;AARd;EAYI,gBAAgB,EAAA","sourcesContent":[".TeamSummary {\n  .team-title {\n    margin-top: 0;\n  }\n\n  .names {\n    list-style: none;\n    text-align: left;\n    padding: 0;\n  }\n\n  & + .TeamSummary {\n    margin-top: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
